import LogoBook from "./svg/LogoBook";
import LogoBiblio from "./svg/LogoBiblio";
import LogoDepMos from "./svg/LogoDepMos";
import IconClock from "./svg/IconClock";

export default {
  logoBook: LogoBook,
  logoBiblio: LogoBiblio,
  logoDepMos: LogoDepMos,
  iconClock: IconClock,
};
